import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Home } from '../../Pages/Public/Home.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteHome = () => {
    const backend = HostBackend();
    const [show, setShow] = useState(0);
    const [guest, setGuest] = useState([]);
    const [parks, setParks] = useState([]);
    const [body, setBody] = useState([]);
    const [att, setAtt] = useState([]);
    const [cha, setCha] = useState([]);
    const [arc, setArc] = useState([]);
    const [ren, setRen] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasGuest = await fetch(`${backend}/auth/public/guest`);
            const guest = await datasGuest.json();
            setGuest(guest);
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest.token));
            const parks = await datasParks.json();
            setParks(parks);
            const dataAtt = await fetch(`${backend}/nav/attractions`, GetHeaders(guest.token));
            const att = await dataAtt.json();
            setAtt(att);
            const dataCha = await fetch(`${backend}/nav/characters`, GetHeaders(guest.token));
            const cha = await dataCha.json();
            setCha(cha);
            const dataArc = await fetch(`${backend}/nav/archives`, GetHeaders(guest.token));
            const arc = await dataArc.json();
            setArc(arc);
            const dataRen = await fetch(`${backend}/nav/rencontres`, GetHeaders(guest.token));
            const ren = await dataRen.json();
            setRen(ren);
            const datasBody = await fetch(`${backend}/home/body`, GetHeaders(guest.token));
            const body = await datasBody.json();
            setBody(body);
        };
        fetchData();
    }, [backend, guest.token]);
    sessionStorage.setItem('guest', guest.token);
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home navParks={navParks} body={body} att={att} ren={ren} arc={arc} cha={cha} />} />
                <Route path="*" element={<NotFound navParks={navParks} show={show} setShow={setShow} />} />
            </Routes>
        </BrowserRouter>
    )
}